<a href="https://wa.me/{{this.whatsappNumber}}" *ngIf="this.whatsappNumber!=''" class="whatsapp-float" target="_blank">
  <i class="fa-brands fa-whatsapp"></i>
</a>
 